import React from "react";
import styles from "./toggle-field.module.scss";

interface ToggleFieldProps {
	checked: boolean;
	onChange: (checked: boolean) => void;
	disabled?: boolean;
}

const ToggleField: React.FC<ToggleFieldProps> = ({ checked, onChange, disabled = false }) => {
	return (
		<button
			type="button"
			role="switch"
			aria-checked={checked}
			disabled={disabled}
			onClick={() => !disabled && onChange(!checked)}
			className={`${styles.switch} ${checked ? styles.checked : ""} ${disabled ? styles.disabled : ""}`}
		>
			<span className={styles.thumb} />
		</button>
	);
};

export default ToggleField;
